import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './hotels-attractions-information.styles';
// import LocationIcon from '../../../icons/Location';
import LocationPinIcon from '@stencil/flights-icons/src/location-pin';

const HotelsAttractionsInformation = ({
  hotelsAttractions,
  hotelsAttractionsType,
  headerTitle,
  footerTitle,
  destUrl,
  isDweb = false
}) => {
  if (hotelsAttractions.length < 1) {
    return null;
  }

  const hotelAttractionsClickHandler = (link, type) => {
    if (type === 'hotels') {
      window.location.href = 'https://goibibo.com/hotels/' + link;
    } else {
      window.location.href = 'https://goibibo.com/' + link;
    }
  };

  const viewAllClickHandler = (link, type) => {
    if (type === 'hotels') {
      window.location.href = link;
    } else {
      window.location.href = 'https://goibibo.com' + link;
    }
  };

  return (
    <C.Wrap isDweb={isDweb}>
      <S.Details className="flexCol">
        <S.Header>{headerTitle}</S.Header>
        {hotelsAttractions.map((hotelAttraction, index) => {
          let name, gir_rating, price, img_display, loc, distance, short, link;
          name = hotelAttraction.name;
          if (hotelsAttractionsType === 'hotels') {
            gir_rating = hotelAttraction.gir_rating;
            price = hotelAttraction.price || hotelAttraction.price.go_201;
            img_display = hotelAttraction.img_display;
            loc = hotelAttraction.loc;
            distance = hotelAttraction.distance;
            link = hotelAttraction.link_slug;
          } else {
            img_display = hotelAttraction.img;
            short = hotelAttraction.desc.short;
            link = hotelAttraction.link;
          }

          return (
            <S.Container key={index}>
              <S.ImageWrap>
                <S.ListItemImg
                  src={img_display}
                  alt="img-hotel"
                  loading="lazy"
                  onClick={() => hotelAttractionsClickHandler(link, hotelsAttractionsType)}
                />
              </S.ImageWrap>
              <S.ContentWrap>
                <S.Name onClick={() => hotelAttractionsClickHandler(link, hotelsAttractionsType)}>
                  {name}
                </S.Name>
                {/* <S.Rating><RatingStarIcon width='1.5rem' height='1.5rem' /><RatingStarIcon width='1.5rem' height='1.5rem' /><RatingStarIcon width='1.5rem' height='1.5rem' /></S.Rating> */}
                {hotelsAttractionsType === 'hotels' ? (
                  <div>
                    <S.Price>
                      &#8377;{price.go_201 || price.go_101}
                      <S.RatingNum>
                        <b>{gir_rating}</b> / 5
                      </S.RatingNum>
                    </S.Price>
                    <S.Location>
                      <LocationPinIcon width="1.8rem" height="1.8rem" fill="#377dd8" />
                      <S.Adress>
                        <div>{loc}</div>
                        <div>approx {distance} kms</div>
                      </S.Adress>
                    </S.Location>
                  </div>
                ) : (
                  <S.AttractionInfo>{short}</S.AttractionInfo>
                )}
              </S.ContentWrap>
            </S.Container>
          );
        })}
        <S.FooterWrap>
          <S.Footer onClick={() => viewAllClickHandler(destUrl, hotelsAttractionsType)}>
            {footerTitle}
          </S.Footer>
        </S.FooterWrap>
      </S.Details>
    </C.Wrap>
  );
};

export default HotelsAttractionsInformation;
